import { API_PATHS } from "../constants/api-paths";
import { type IResponse, encryptedRequest } from "../core/api.client";

export interface ISendOtpApiResponse {
  requestId: string;
}

export const sendOtp = async (mobileNo: string): Promise<IResponse<ISendOtpApiResponse>> => {
  const response = await encryptedRequest<ISendOtpApiResponse>({
    method: "POST",
    url: API_PATHS.sendOtp,
    data: {
      mobileNo,
    },
  });

  if (response.statusCode === 90) {
    // Response contains requestId - caller can use it to manage OTP modal state
    // Previous: setOtpVerifyModalStatus({ requestId: response.data.requestId })
    return response;
  }

  if (response.statusCode === 96) {
    return response;
  }

  throw new Error(response.message);
};

export const verifyOtp = async (
  mobileNo: string,
  requestId: string,
  otp: string
): Promise<IResponse<string>> => {
  const response = await encryptedRequest<string>({
    method: "POST",
    url: API_PATHS.verifyOtp,
    data: {
      mobileNo,
      requestId,
      otp,
      authType: "I",
    },
  });
  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};

export const logout = async (mobileNo: string, p_token?: string): Promise<IResponse<string>> => {
  const response = await encryptedRequest<string>({
    method: "POST",
    url: API_PATHS.logout,
    data: {
      mobileNo,
      p_token,
    },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};
